export const BRANDS = [
  { id: "barkode", name: "Bark'ode", branches: ["Pattom", "Karyavattom"] },
  { id: "kennelmart", name: "Kennel Mart", branches: ["Kottayam", "Changanassery", "Chengannur"] },
];

export const brandName = (id) => BRANDS.find((b) => b.id === id)?.name || (id ? id : "All Brands");
export const branchesFor = (id) => BRANDS.find((b) => b.id === id)?.branches || [];

export const money = (v) =>
  v == null || v === "" ? "—" : `₹${Number(v).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const GROOMING_CATALOG = [
  { key: "haircut", label: "Haircut", type: "multi", options: ["Zero Trim", "Summer Cut", "Short Puppy Cut", "Regular Puppy Cut", "Medium Haircut and Shaping"] },
  { key: "hairstyles", label: "Hairstyles", type: "multi", options: ["Poodle Cut", "Teddy Bear Cut", "Line Cut"] },
  { key: "requirements", label: "Requirements", type: "desc", options: ["Head", "Face", "Underbody", "Paws", "Tail"] },
  { key: "bathing", label: "Bathing", type: "multi", options: ["Premium Bath Package", "Medicated Bath Package", "Dry Bathing"] },
  { key: "ear_cleaning", label: "Ear Cleaning", type: "single" },
  { key: "nails", label: "Nails", type: "multi", options: ["Nail Cut", "Nail Grinding"] },
  { key: "hygiene", label: "Hygiene Area", type: "multi", options: ["Paws", "Sanitary Area", "Comfort Area"] },
  { key: "deshedding", label: "Deshedding", type: "single" },
  { key: "dematting", label: "Dematting", type: "dematting", options: ["Mats", "Combing"] },
];

export const GROOMING_CONDITIONS = ["Infection", "Ticks", "Mats", "Skin Condition"];

export const ageBand = (dob) => {
  if (!dob) return "adult";
  const yrs = (Date.now() - new Date(dob)) / (365.25 * 864e5);
  return yrs < 1 ? "puppy" : yrs < 7 ? "adult" : "senior";
};
export const ageBandLabel = { puppy: "Puppy", adult: "Adult", senior: "Senior" };
export const ageFromDob = (dob) => {
  if (!dob) return "";
  const d = new Date(dob);
  if (isNaN(d)) return "";
  const now = new Date();
  let m = (now.getFullYear() - d.getFullYear()) * 12 + (now.getMonth() - d.getMonth());
  if (now.getDate() < d.getDate()) m--;
  if (m < 0) return "";
  const y = Math.floor(m / 12), mo = m % 12;
  return y < 1 ? `${mo} mo` : `${y}y ${mo}m`;
};
